<template>
  <div class="cm-section-body" :class="{ 'is-off': off }">
    <slot />
  </div>
</template>

<script>
import { hiddenStore } from "@/models/content-monitoring/hidden-panels";

export default {
  name: "Cm-section-body",
  props: {
    block: { type: String, required: true },
  },
  computed: {
    off() {
      return hiddenStore.ids.indexOf(this.block) !== -1;
    },
  },
};
</script>
